import { Component } from '@angular/core';

import { take, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SingleDetailComponent } from 'app/shared/components/single-detail/single-detail.component';
import { IOutbountTransitUnitSummaryModel } from 'app/shared/models/outbound.models';
import { LogisticsOutboundService } from 'app/shared/services/outbound.service';

import { ScannedDetailsComponentBase } from '../ScannedDetailsComponentBase';

@Component({
  selector: 'app-scanned-transit-unit-details',
  templateUrl: './scanned-transit-unit-details.component.html',
  styleUrls: ['./scanned-transit-unit-details.component.css'],
  standalone: true,
  imports: [SingleDetailComponent],
})
export class ScannedTransitUnitDetailsComponent extends ScannedDetailsComponentBase {
  public outbountTransitUnitSummaryModel: IOutbountTransitUnitSummaryModel;

  constructor(private outboundService: LogisticsOutboundService) {
    super();
  }

  handleCodeScanned(): void {
    this.outboundService
      .getOutboundTransitUnitDetailByLabelCodeV1(this.labelCode.identifier)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (outbountTransitUnitSummaryModel: IOutbountTransitUnitSummaryModel) => {
          this.outbountTransitUnitSummaryModel = outbountTransitUnitSummaryModel;
          this.navigationInstructions.emit([`/logistics/outbound`, outbountTransitUnitSummaryModel.outboundId]);
        },
        error: (_error) => this.handleScanFail(),
      });
  }
}
